
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/living",
      function () {
        return require("private-next-pages/egypt/living/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/living"])
      });
    }
  